import React, { useState, useEffect } from "react";

import { Row, Col, Button, Form, Modal, Image } from "react-bootstrap";

import checkmark from "../../assets/icons/checkmark.png";
// Recaptcha
import { GoogleReCaptchaProvider, GoogleReCaptcha } from "react-google-recaptcha-v3";
//utilities
import useWindowDimensions from "../../utils/useWindowDimensions";
import { CountrySelector } from '../../utils/react-country-selector/components/selector';
import { COUNTRIES } from '../../utils/react-country-selector/constants/countries';
import { SelectMenuOption } from '../../utils/react-country-selector/types/index';
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input/input'
import validator from 'validator';
import styles from "./ProposalForm.module.css";
// import { CountryCode } from "libphonenumber-js/types";
import libphonenumber from 'google-libphonenumber';

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();


function ProposalSubmissionModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={styles.modalMain}
        >
            {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Modal heading
          </Modal.Title>
        </Modal.Header> */}
            <Modal.Body>
                <div className={styles.modalTitle}>
                    <Image src={checkmark} className={styles.modalCheckmark}></Image>
                    <div className={styles.modalTitleText}>
                        Your Proposal is Submitted
                    </div>
                </div>
                <div className={styles.modalBodyText}>
                    We will review your proposal before publishing.
                </div>
                <div className={styles.modalFooterText}>
                    Thank you for your contribution
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
        </Modal>
    );
}

const initialState = ({
    name: "",
    email: "",
    country: "BE",
    phone: "",
    proposalTitle: "",
    proposalDescription: "",
    website: "",
    terms: false
})

function ProposalForm() {

    const myRef = React.createRef<HTMLDivElement>();
    const [isCountryOpen, setisCountryOpen] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);
    const [form, setForm] = useState(initialState);

    useEffect(() => {
    }, []);


    const [errors, setErrors] = useState<any>({})

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
        if (!!errors[field]) setErrors({
            ...errors,
            [field]: null
        })
    }



    const findFormErrors = () => {
        const { name, email, country, phone, proposalTitle, proposalDescription, website, terms } = form
        const newErrors: any = {}

        if (!name || name === '') newErrors.name = 'Your name is required'
        else if (name.length > 30) newErrors.name = 'Should not be more than 30 characters'

        if (!email || email === '') newErrors.email = 'Your email is required'
        else if (validator.isEmail(email) == false) newErrors.email = 'Invalid email format'

        if (!phone || phone === '') newErrors.phone = 'You must enter a phone number'
        else if (phoneUtil.isValidNumberForRegion(phoneUtil.parseAndKeepRawInput(phone), country) == false) newErrors.phone = 'The phone number should be valid to the country region'

        if (!proposalTitle || proposalTitle === '') newErrors.proposalTitle = 'Please enter a proposal title'
        else if (proposalTitle.length < 50) newErrors.proposalTitle = 'Should not be more than 50 characters'

        if (!proposalDescription || proposalDescription === '') newErrors.proposalDescription = 'The proposal description is required'

        if (!website || website === '') newErrors.website = 'Please enter a website for the proposal'
        else if (validator.isURL(website) == false) newErrors.website = 'Enter a valid website url'

        if (!terms) newErrors.terms = 'You must agree to the proposal terms'

        return newErrors
    }
    const handleSubmit = e => {
        e.preventDefault()
        // get our new errors
        const newErrors = findFormErrors()
        // Conditional logic:
        if (Object.keys(newErrors).length > 0) {
            // We got errors!
            setErrors(newErrors)
        } else {
            // No errors! Put any logic here for the form submission!
            setModalShow(true)
        }
    }

     // Recaptcha
     function onVerify(value){
        console.log("Captcha value:", value);
    }
    

    const { height, width } = useWindowDimensions();

    return (
        <Row className={styles.ContentContainer}>
            <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3" style={{ textAlign: 'left' }}>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Name</Form.Label>
                        <Form.Control
                            size="lg"
                            name="name"
                            type="text"
                            placeholder="Enter your name"
                             value={form.name}
                            onChange={e => setField('name', e.target.value)}
                            // isValid={touched.name && !errors.name}
                            isInvalid={!!errors.name}
                            className={styles.inputStyle}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Email</Form.Label>
                        <Form.Control
                            size="lg"
                            name="email"
                            type="text"
                            placeholder="Enter your email"
                            value={form.email}
                            onChange={e => setField('email', e.target.value)}
                            // isValid={touched.email && !errors.email}
                            isInvalid={!!errors.email}
                            className={styles.inputStyle}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row className="mb-3" style={{ textAlign: 'left' }}>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Country</Form.Label>
                        <CountrySelector
                            id={'countries'}
                            ref={myRef}
                            open={isCountryOpen}
                            onToggle={() => setisCountryOpen(!isCountryOpen)}
                            onChange={country => setField('country', country)}
                            selectedValue={COUNTRIES.find(option => option.value === form.country) as SelectMenuOption}
                        />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Phone</Form.Label>

                        <Form.Control
                            as={Input}
                            name="phone"
                            placeholder="Enter phone number"
                            className={styles.phoneInput}
                            country={`${form.country}`}
                            onChange={phone => setField('phone', phone)}
                            value={form.phone}
                            isInvalid={!!errors.phone}

                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.phone}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row className="mb-3" style={{ textAlign: 'left' }}>
                    <Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Proposal Title</Form.Label>
                        <Form.Control
                            size="lg"
                            name="proposalTitle"
                            type="text"
                            placeholder="Enter your proposal title"
                            className={styles.inputStyle}
                            onChange={e => setField('proposalTitle', e.target.value)}
                            value={form.proposalTitle}
                            isInvalid={!!errors.proposalTitle}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.proposalTitle}
                        </Form.Control.Feedback>
                    </Form.Group><Form.Group as={Col} md="6">
                        <Form.Label className={styles.inputLabel}>Website</Form.Label>
                        <Form.Control
                            size="lg"
                            name="proposalWebsite"
                            type="text"
                            placeholder="Enter your proposal website"
                            className={styles.inputStyle}
                            onChange={e => setField('website', e.target.value)}
                            value={form.website}
                            isInvalid={!!errors.website}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.website}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Row className="mb-3" style={{ textAlign: 'left' }}>
                    <Form.Group as={Col} md="12">
                        <Form.Label className={styles.inputLabel}>Proposal Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            size="lg"
                            name="proposalDescription"
                            type="text"
                            id="descriptionTextArea"
                            // style={{height: document.getElementById("descriptionTextArea").scrollHeight ? document.getElementById("descriptionTextArea").scrollHeight : 50, minHeight: 50}}
                            placeholder="Describe your proposal to the crowd"
                            className={styles.inputStyle}
                            // value={values.proposalDescription}
                            value={form.proposalDescription}
                            onChange={e => setField('proposalDescription', e.target.value)}
                            // isValid={touched.proposalDescription && !errors.proposalDescription}
                            isInvalid={!!errors.proposalDescription}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.proposalDescription}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
                    <Form.Check
                        required
                        name="terms"
                        label="Agree to terms and conditions"
                        onChange={value => setField('terms', value.target.checked)}
                        isInvalid={!!errors.terms}
                        feedback={errors.terms}
                        feedbackType="invalid"
                    />
                </Form.Group>
                <GoogleReCaptchaProvider reCaptchaKey="6Lf4v38fAAAAABsUbQodQPrDFhI_qQbGGl05nJZl" language="en">
                    <GoogleReCaptcha onVerify={onVerify} />
                </GoogleReCaptchaProvider>
                <br/>
                <Button type="submit" className={styles.submitButton}>Submit form</Button>
            </Form>
            <ProposalSubmissionModal show={modalShow} onHide={() => setModalShow(false)} />
        </Row>
    );
}

export default ProposalForm;